import type { MenuItem } from 'primevue/menuitem'
import { PbxPhonebookContactPhoneNumberType, type PbxPhonebookContact } from '@/TcxApi/PbxPhonebook'

export interface GuestInvitePrefill { guestName?: string, sms?: string, email?: string }

type GuestEmit = (event: 'CommonGuestInviteModal' | 'CommonGuestInvitesDialog', payload?: GuestInvitePrefill) => void

/** User-menu entry for guest video invites (one parent with Invite and Invitations); empty unless the customer can create invites (spec §8) */
export function guestMenuItems(canCreate: boolean, translate: (key: string) => string, emit: GuestEmit): MenuItem[] {
	if (!canCreate) { return [] }

	return [
		{ label: translate('guest.videoMenu'), icon: 'pi pi-video', items: [
			{ label: translate('guest.inviteMenu'), icon: 'pi pi-video', command: () => emit('CommonGuestInviteModal', undefined) },
			{ label: translate('guest.listMenu'), icon: 'pi pi-list', command: () => emit('CommonGuestInvitesDialog') }
		] }
	]
}

/** Prefill for the invite modal from a phonebook contact: MOBILE number only (no landline fallback), first e-mail */
export function guestContactPrefill(contact: Pick<PbxPhonebookContact, 'name' | 'phoneNumbers' | 'emailAddresses'>): GuestInvitePrefill {
	return {
		guestName: contact.name ?? undefined,
		sms: contact.phoneNumbers.find(entry => entry.type === PbxPhonebookContactPhoneNumberType.MOBILE)?.number,
		email: contact.emailAddresses[0]?.address
	}
}
